const networkEnum = Object.freeze({
  '0x1': 'Ethereum Main',
  '0x3': 'Ropsten',
  '0x4': 'Rinkeby',
  '0x38': 'BSC',
  '0x89': 'Polygon',
  '0xfa': 'Fantom',
  localhost: 'localhost'
});
export default networkEnum;
